export default {
    setIgnore(isIgnore) {
        localStorage.setItem('ignore_mobile', String(isIgnore));
    },

    isIgnore() {
        return localStorage.getItem('ignore_mobile') === 'true';
    }
}